export function updateGateUseCase(gate_id, gateData, gateRepostitory) {
    const new_gate = new gateRepostitory.model_create(gateData);

    const is_valid = new_gate.isValid();

    if (is_valid != true) {
      throw new Error(is_valid);
    }

    return gateRepostitory.update(gate_id, new_gate);
}